import React, { useState, useEffect } from 'react';
import AWS from 'aws-sdk';
import { Link } from 'react-router-dom';
import CurrencyFormat from 'react-currency-format';
import { FaAngleRight } from "react-icons/fa";
import { Amplify, I18n, Auth, Hub } from 'aws-amplify';
import { Authenticator, translations, Text, Button, Badge } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import './App.css';

import awsExports from './aws-exports';
Amplify.configure(awsExports);

I18n.setLanguage('it');
I18n.putVocabularies(translations);
I18n.putVocabularies({
  it: {
    'Enter your Username': '####',
    'Enter your Password': "Password",
    'Please confirm your Password': "Password",
    'Enter your Email': "Email",
    'User does not exist.': "Utente non registrato",
    "PreSignUp failed with error username_length.": "Il nome utente deve essere di 4 cifre",
    "PreSignUp failed with error name 'username' is not defined.": "Il nome utente deve essere di 4 cifre",
    "Your passwords must match": "Le password non coincidono",
    "Incorrect username or password.": "Credenziali errate"
  },
});

export default function App() {

  const restaurantData = {
    "tuttobenegrazie": {
      restaurant_display_name: "Tutto Bene, Grazie Bistrò",
      restaurant_logo_url: "https://scontrini.gotaac.it/merchant-logos/tbg.jpg"
    },
    "martas": {
      restaurant_display_name: "Martas Nature Bar",
      restaurant_logo_url: "https://scontrini.gotaac.it/merchant-logos/Martas Nature Bar.png"
    },
    "lomdopolavoro": {
      restaurant_display_name: "Lom Dopolavoro",
      restaurant_logo_url: "https://menu.gotaac.it/lomdopolavoro.jpg"
    }
  };

  const [content, setContent] = useState([]);
  const [expandedCard, setExpandedCard] = useState(null);

  useEffect(() => {
    // Configure the AWS SDK
    AWS.config.update({
      region: 'eu-west-1',
      accessKeyId: 'AKIAYFDYAK75ALG6K3RK',
      secretAccessKey: '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'
    });

    // Handle user authentication
    let updateUser = async authState => {
      try {
        let user = await Auth.currentAuthenticatedUser()
        loadReceipts(user);
      } catch {
        console.log("User not authenticated.")
      }
    }
    // Listen for login/signup events
    Hub.listen('auth', updateUser)
    // Check manually the first time because we won't get a Hub event
    updateUser()
    // Cleanup
    return () => Hub.remove('auth', updateUser)
  }, []);

  function loadReceipts(user) {
    // Create a new DynamoDB service object
    const dynamoDb = new AWS.DynamoDB();
    // Define the parameters for the query operation
    const params = {
      TableName: 'taac-guests-webapp-orders',
      KeyConditionExpression: "#username = :username",
      ExpressionAttributeNames: {
        "#username": "username",
      },
      ExpressionAttributeValues: {
        ":username": {
          N: user.username,
        },
      },
    };
    // Call the query method to retrieve all items in the table for the user
    dynamoDb.query(params, (err, data) => {
      if (err) {
        console.log(err);
      } else {
        setContent(data.Items);
      }
    });
  }

  function openDigitalReceipt(url) {
    setTimeout(() => {
      window.open(url, 'download=false');
    })
  }

  function formatDate(dateString) {
    let date = new Date(dateString.slice(0, 4), dateString.slice(4, 6) - 1, dateString.slice(6, 8), dateString.slice(8, 10), dateString.slice(10, 12), dateString.slice(12, 14));
    return date.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit"}).replace(/\//g, "/").replace(/\s/, " - ").replace(/\,/, "");
  }  

  const components = {
    Header() {
      return (
        <div className='auth-header'>
          <img
            className='auth-logo'
            alt="taac logo"
            src="https://scontrini.gotaac.it/taac-logo-header.png"
          />
        </div>
      );
    },
    SignUp: {
      Header() {
        return (
          <Text
            className='auth-signup-header'
            fontWeight={"bold"}
            fontSize={"1.4rem"}
          >
            Scegli un nome utente da 4 cifre
          </Text>
        );
      },
    }
  }

  return (
    <Authenticator variation='modal' initialState="signUp" components={components}>
      {({ user }) => (
        <main>
          <div className="navbar">
            <img src="https://scontrini.gotaac.it/taac-logo-header.png" className="logo" alt="taac logo" />
          </div>

          <div className='pageContent'>
            <div className='card'>
              <Link to="/profile" className='flex-row-space-between'>
                <div>
                  <Text
                    fontWeight={'bold'}
                    fontSize={'1.4rem'}
                  >
                    taac id
                  </Text>
                  <div className='flex'>
                    <div>
                      <Text
                        fontWeight={'extrabold'}
                        fontSize={'2.5rem'}
                        color={"#ee492f"}>
                        {user.username}
                      </Text>
                    </div>
                  </div>
                </div>
                <div className='flex-align-center'>
                  <Text><FaAngleRight /></Text>
                </div>
              </Link>
            </div>

            <div className="card">
              <Text
                fontWeight={'bold'}
                fontSize={'1.4rem'}
              >
                ultimi scontrini
              </Text>
              <div>
                {content.length === 0 ? <Text className='single-gap'>nessuno scontrino da visualizzare</Text> : null}
                <div>
                  {content
                    .sort((a, b) => b.date.S.localeCompare(a.date.S))
                    .slice(0, 2).map((item, index) => (
                      <div className={`card ${expandedCard === index ? 'expanded' : ''}`} key={index}>
                        <div className='flex' onClick={() => setExpandedCard(expandedCard === index ? null : index)}>
                          <img className='venue-logo-small' src={restaurantData[item.restaurant_name.S].restaurant_logo_url} alt="restaurant logo" />
                          <div className='venue-info'>
                            <div className='flex-row-space-between'>
                              <Text fontSize={"0.9rem"}>{formatDate(item.date.S)}</Text>
                              <Badge
                                size='small'>
                                <CurrencyFormat value={item.order_total.N} displayType={'text'} thousandSeparator={true} prefix={'€'} decimalScale={2} fixedDecimalScale={true} />
                              </Badge>
                            </div>
                            <Text fontWeight={"bold"} fontSize={"1.08rem"}>{restaurantData[item.restaurant_name.S].restaurant_display_name}</Text>
                          </div>
                        </div>
                        {expandedCard === index && (
                          <>
                            <Button
                              className="single-gap"
                              variation={'secondary'}
                              onClick={() => openDigitalReceipt(item.fiscal_printer_link.S)}
                              isFullWidth={true}>
                              scarica scontrino digitale
                            </Button>
                          </>
                        )}
                      </div>
                    ))}
                </div>
              </div>
              {content.length !== 0 ?
                <Link to="/receipts">
                  <Button
                    className="single-gap button-black"
                    isFullWidth='true'>
                    vedi tutti ({content.length})
                  </Button>
                </Link>
                : null}
            </div>
          </div>
        </main>
      )}
    </Authenticator>
  );
}